import React from 'react';
import { Building } from 'lucide-react';

interface NameSectionProps {
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: (fieldName: string) => void;
  onBlur: (fieldName: string) => void;
  placeholder: string;
}

export const NameSection: React.FC<NameSectionProps> = ({
  name,
  onChange,
  onFocus,
  onBlur,
  placeholder
}) => {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center space-x-2">
        <Building className="w-5 h-5 text-blue-600" />
        <span>Name</span>
      </h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Outlet Name</label>
        <input
          type="text"
          name="name"
          value={name}
          onChange={onChange}
          onFocus={() => onFocus('name')}
          onBlur={() => onBlur('name')}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default NameSection;
